import LandingPageContainer from 'components/LandingPage/LandingPageContainer'

export default {
  Container: LandingPageContainer,
}
